import React, { useState } from "react"
import types from "prop-types"
import { connect } from "react-redux"
import { FormSubmissionAuditTrailContextProvider } from "contexts/FormSubmissionAuditTrailContext"
import LoadMoreButton from "./LoadMoreButton"
import AuditsHeader from "./AuditsHeader"
import FormSubmissionAuditTrailGroups from "./FormSubmissionAuditTrailGroups"
import OptionsSidebar from "./OptionsSidebar"

export const AUDIT_TRAIL_TAB_ID = "tab-audit-trail"
export const AUDIT_TRAIL_TAB_PANEL_ID = "tabpanel-audit-trail"

const AuditTrailContent = ({ formSubmissionSlug = "" }) => {
  const [hiddenSidebar, setHiddenSidebar] = useState(true)
  const toggleSidebar = () => setHiddenSidebar(!hiddenSidebar)

  return (
    <FormSubmissionAuditTrailContextProvider formSubmissionSlug={formSubmissionSlug}>
      <div id={AUDIT_TRAIL_TAB_PANEL_ID} className="flex grow" role="tabpanel" aria-labelledby={AUDIT_TRAIL_TAB_ID}>
        <OptionsSidebar hiddenSidebar={hiddenSidebar} />
        <div className="flex-1 min-w-0">
          <div className="inner-container mx-auto max-w-screen-xl">
            <AuditsHeader hiddenSidebar={hiddenSidebar} toggleSidebar={toggleSidebar} />
            <FormSubmissionAuditTrailGroups />
            <LoadMoreButton />
          </div>
        </div>
      </div>
    </FormSubmissionAuditTrailContextProvider>
  )
}

AuditTrailContent.propTypes = {
  formSubmissionSlug: types.string,
}

const mapStateToProps = (state) => (
  {
    formSubmissionSlug: state.formSubmission.data.slug,
  }
)

export default connect(mapStateToProps, {})(AuditTrailContent)
